export default "__VITE_ASSET__22ccedb3__"